import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const validatorWorkOrderEquipment = v.object({
  workOrderId: v.id("work_orders"),
  equipmentId: v.id("equipment"),
  usageStart: v.optional(v.number()),
  usageEnd: v.optional(v.number()),
  usageCost: v.optional(v.number()),
  notes: v.optional(v.string()),
  internalControl,
});

export const work_order_equipment = defineTableWithInternalControl(
  validatorWorkOrderEquipment,
)
  .index("by_work_order", ["workOrderId"])
  .index("by_equipment", ["equipmentId"])
  .index("by_work_order_and_equipment", ["workOrderId", "equipmentId"])
  .index("by_company_and_work_order", [
    "internalControl.companyId",
    "workOrderId",
  ])
  .index("by_branch_and_work_order", [
    "internalControl.branchId",
    "workOrderId",
  ]);
